import _pt from "prop-types";
import React, { memo } from "react";
import classNames from "classnames";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { brandBackgroundPrimaryColor, iconBaseColor } from "@optimizely/design-tokens/dist/json/colors.json";
import { brandIcons } from "./icon-types";
//import * as fa from "./icon-imports";
import { AppPushIcon, WebPushIcon } from "./custom-icons"; // @ts-ignore: The beta package has changed the type definitions

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//library.add(fa);
var Icon = memo(function (_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? iconBaseColor : _ref$color,
      name = _ref.name,
      size = _ref.size,
      title = _ref.title,
      transform = _ref.transform,
      props = _objectWithoutProperties(_ref, ["className", "color", "name", "size", "title", "transform"]);

  // Check for custom icons first. If this starts getting long we can separate it out.
  var customIcon;

  switch (name) {
    case "ax-app-push":
      customIcon = React.createElement(AppPushIcon, {
        className: className,
        color: color,
        size: size,
        title: title
      });
      break;

    case "ax-app-push-thin":
      customIcon = React.createElement(AppPushIcon, {
        className: className,
        color: color,
        size: size,
        title: title,
        weight: "thin"
      });
      break;

    case "ax-web-push":
      customIcon = React.createElement(WebPushIcon, {
        className: className,
        color: color,
        size: size,
        title: title
      });
      break;

    case "ax-web-push-thin":
      customIcon = React.createElement(WebPushIcon, {
        className: className,
        color: color,
        size: size,
        title: title,
        weight: "thin"
      });
      break;
  }

  if (customIcon) {
    return customIcon;
  } // FontAwesome uses the same icon name no matter the weight, so we strip off
  // our weight indicator and then change the icon weight prefix if necessary


  var strippedName = name;
  var weight = brandIcons.includes(name) ? "fab" : "fal";

  if (name.endsWith("-regular")) {
    weight = "far";
    strippedName = name.replace("-regular", "");
  } else if (name.endsWith("-solid")) {
    weight = "fas";
    strippedName = name.replace("-solid", "");
  } else if (name.endsWith("-thin")) {
    weight = "fat";
    strippedName = name.replace("-thin", "");
  }

  return React.createElement(FontAwesomeIcon, _extends({
    className: classNames("axiom-icon", "axiom-icon--".concat(size), "fa-fw", className),
    color: color,
    icon: [weight, strippedName],
    title: title,
    transform: transform
  }, props));
});
Icon.propTypes = {
  className: _pt.string,
  color: _pt.string,
  name: _pt.any.isRequired,
  size: _pt.oneOf(["small", "medium", "large"]).isRequired,
  title: _pt.string,
  transform: _pt.string
};

var OutlinedIcon = function OutlinedIcon(_ref2) {
  var className = _ref2.className,
      color = _ref2.color,
      name = _ref2.name,
      _ref2$outlineColor = _ref2.outlineColor,
      outlineColor = _ref2$outlineColor === void 0 ? brandBackgroundPrimaryColor : _ref2$outlineColor,
      size = _ref2.size,
      title = _ref2.title,
      transform = _ref2.transform,
      props = _objectWithoutProperties(_ref2, ["className", "color", "name", "outlineColor", "size", "title", "transform"]);

  return React.createElement(React.Fragment, null, React.createElement(Icon, {
    className: "axiom-icon-outline",
    color: outlineColor,
    name: name // @ts-ignore
    ,
    style: {
      stroke: "".concat(outlineColor)
    },
    transform: transform
  }), React.createElement(Icon, _extends({
    className: className,
    color: color,
    name: name,
    size: size,
    title: title,
    transform: transform
  }, props)));
};

OutlinedIcon.propTypes = {
  className: _pt.string,
  color: _pt.string,
  name: _pt.any.isRequired,
  size: _pt.oneOf(["small", "medium", "large"]).isRequired,
  title: _pt.string,
  transform: _pt.string,
  outlineColor: _pt.string
};

var LayeredIcons = function LayeredIcons(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      size = _ref3.size,
      props = _objectWithoutProperties(_ref3, ["children", "className", "size"]);

  return React.createElement("span", _extends({
    className: classNames("axiom-layered-icons", "axiom-icon--".concat(size), "fa-layers fa-fw", className)
  }, props), children);
};

LayeredIcons.propTypes = {
  children: _pt.any,
  className: _pt.string,
  size: _pt.oneOf(["small", "medium", "large"]).isRequired,
  title: _pt.string
};
Icon.displayName = "Icon";
OutlinedIcon.displayName = "OutlinedIcon";
LayeredIcons.displayName = "LayeredIcons";
export { Icon, OutlinedIcon, LayeredIcons };